/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useTypedSelector } from "../../redux/hooks";
import ChatBody from "./ChatBody";
import ContactNamesProvider from "../phone/GetContactNamesContext";
import { isPulseHd } from '../../helpers';
import { selectActiveConversation } from '../../redux/slices/chatNSlice';
import WelcomeScreen from '../chatG/WelcomeScreen';
import ConversationProvider from '../../context/ChatContext/contextConvo';

export const ChatN: React.FC = () => {
    const active = useTypedSelector(selectActiveConversation);

    if (!active) {
        return <WelcomeScreen />;
    }

    return (
        <div className={['chat-container', isPulseHd ? 'ip' : ''].join(' ')}>
            <ContactNamesProvider>
                <ConversationProvider key={active.uuid} conversation={active}>
                    <ChatBody key={active.uuid} />
                </ConversationProvider>
            </ContactNamesProvider>
        </div>
    );
};

export default ChatN;
